// Add at the top of VNTable.tsx
import { useDroppable } from '@dnd-kit/core';
import { TableCell, TableRow, Typography } from '@mui/material';

// ── Drop Zone Row ─────────────────────────────────────────────────────────────
const DropZoneRow: React.FC<{ tableId: string; colSpan: number; dragAndDropText: string }> = ({
  tableId,
  colSpan,
  dragAndDropText,
}) => {
  const { setNodeRef, isOver } = useDroppable({ id: `${tableId}-drop-zone` });

  return (
    <TableRow ref={setNodeRef}>
      <TableCell colSpan={colSpan} className={`dropzone-cell ${isOver ? 'is-over' : ''}`}>
        <Typography
          variant="body2"
          sx={{
            color: isOver ? '#6366f1' : '#94a3b8',
            fontStyle: 'italic',
          }}
        >
          {isOver ? '📥 Release to drop here' : dragAndDropText || 'Drag and Drop here'}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default DropZoneRow;
